<template>
  <div class="-info-text">
    <div class="-script-container">
      <textarea
        dir="auto"
        :value="value"
        class="-script-input recoder-input-target"
        :placeholder="
          isAiVoiceType
            ? 'Type in your script...'
            : 'Type in your script (optional)...'
        "
        :disabled="isRecording"
        @input="onInput"
      ></textarea>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoiceOverScript',

  props: {
    value: {
      type: String,
      default: '',
    },
    isRecording: {
      type: Boolean,
      default: false,
    },
    isAiVoiceType: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      script: '',
    };
  },

  computed: {},

  methods: {
    onInput(event) {
      this.$emit('input', event.target.value);
    },

    // Method to get script content for teleprompter
    getScript() {
      return this.script;
    },
  },
};
</script>

<style lang="scss" scoped>
.-info-text {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px;

  .-script-container {
    width: 100%;
    height: 100%;
  }

  .-script-input {
    width: 100%;
    height: 100%;
    // padding: 15px;
    // border: 1px solid #d9d9d9;
    background: transparent;
    border: none;
    // border-radius: 4px;
    font-size: 16px;
    line-height: 1.5;
    transition: border-color 0.3s ease;
    resize: none;
    overflow-y: auto;

    &:focus {
      outline: none;
      border-color: #4db6ac;
    }

    &:disabled {
      //   background-color: #f5f5f5;
      cursor: not-allowed;
    }

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }

  .-character-count {
    position: absolute;
    bottom: -25px;
    right: 0;
    font-size: 12px;
    color: rgba(0, 0, 0, 0.5);
  }

  .-hint {
    margin-top: 30px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
    text-align: center;
  }
}
</style>
